import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../SalesJourney/microServiceBase";
var AOPOrderbookURL = {
    dashboardData: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Dashboard/getdata",
    dashboardDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Dashboard/getdata",
    clientDetails: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "ApplicationDetails/getclientdata",
    clientDetailsV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/ApplicationDetails/getclientdata",
    selfieLinkData: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Communication/selfielink",
    selfieLinkDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Communication/selfielink",
    eSignLinkData: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Communication/esignlink",
    eSignLinkDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Communication/esignlink",
    getKycData: URLConfig.config.aopBaseURL + microService.AOPOBSERVICE + "Document/getkyc",
    getKycDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Document/getkyc",
    getClientFilterData: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Filters/getclientsearchdata",
    getClientFilterDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Filters/getclientsearchdata",
    downloadData: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Dashboard/downloaddata",
    downloadDataV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Dashboard/downloaddata",
    verificationLink: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "Communication/verificationlink",
    verificationLinkV2: URLConfig.config.aopBaseURL +
        microService.AOPOBSERVICE +
        "v2/Communication/verificationlink",
};
export default AOPOrderbookURL;
